import {
  ApplicationConfig,
  importProvidersFrom,
  APP_INITIALIZER,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
} from '@angular/router';
import { routes } from './app.routes';
import { provideDaterangepickerLocale } from 'ngx-daterangepicker-bootstrap';
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { authInterceptor } from '@core/providers/auth.interceptor';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { ApiTranslateLoader } from '@core/services/api-translate-loader.service';
import { AuthService } from '@core/services/auth.service';
import { UserService } from '@core/services/user.service';

export function appInitializerFactory(
  auth: AuthService,
  translate: TranslateService,
  userService: UserService
) {
  return async () => {
    const lang = localStorage.getItem('app_language') || 'en';
    translate.setDefaultLang(lang);

    await new Promise<void>((resolve) => {
      translate.use(lang).subscribe({
        next: () => resolve(),
        error: () => resolve(),
      });
    });

    const token = localStorage.getItem('access_token');
    if (!token || !auth.hasValidToken()) {
      return;
    }

    const userInfo = localStorage.getItem('user_info');
    if (userInfo) {
      userService.setUserInfo(JSON.parse(userInfo));
    }

    await userService.loadUserInfo();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(routes, withEnabledBlockingInitialNavigation()),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: ApiTranslateLoader,
          deps: [HttpClient],
        },
      })
    ),

    provideDaterangepickerLocale({
      separator: ' - ',
      cancelLabel: 'Cancel',
    }),

    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [AuthService, TranslateService, UserService],
      multi: true,
    },
  ],
};
